import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ViewEncapsulation,
  computed,
  inject,
  input,
  signal,
} from '@angular/core'

import { FlxStyleModule, FlxWrapperStyleDirective } from '@flowx/angular-theme'
import { FlxThemeModule } from '@flowx/angular-theme'
import { TaskManagementTemplateConfig, config } from '@flowx/core-sdk'
import { ContainerStyles, DimensionTypes, calculateFillHeight } from '@flowx/core-theme'

import { FlxTasksManagementComponent } from '../../task-management/components/flx-task-management/flx-task-management.component'

@Component({
  selector: 'flx-task-management-wrapper',
  hostDirectives: [
    { directive: FlxWrapperStyleDirective, inputs: ['flxWrapperStyle: templateConfig'] },
  ],
  host: {
    '[style.height]': 'fillHeight()',
  },
  imports: [FlxTasksManagementComponent, FlxStyleModule, FlxThemeModule],
  templateUrl: './flx-task-management-wrapper.component.html',
  styleUrl: './flx-task-management-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class FlxTaskManagementWrapperComponent implements AfterViewInit {
  #elementRef = inject(ElementRef)
  config = config()
  templateConfig = input.required<TaskManagementTemplateConfig>()
  displayOptions = computed(() => this.templateConfig().displayOptions)
  resourceDefinitionId = computed(
    () => this.displayOptions().flowxProps?.taskManagementView?.resDefId
  )
  style = computed(() => this.displayOptions().style as ContainerStyles)

  isFillHeight = computed(() => (this.style().heightType as DimensionTypes) === DimensionTypes.Fill)
  fillHeight = signal<string | undefined>(undefined)

  containerHeight = computed(() => {
    if (this.isFillHeight() && this.fillHeight()) {
      return '100%'
    }
    if (this.style().heightType === DimensionTypes.Fixed && this.style().height) {
      return `${this.style().height}px`
    }
    return undefined
  })

  ngAfterViewInit(): void {
    if (this.isFillHeight()) {
      setTimeout(() => {
        // TODO: temp solution until generic fill-height mechanism exists
        this.fillHeight.set(calculateFillHeight(this.#elementRef.nativeElement))
      }, 0)
    }
  }
}
